import { combineEpics } from 'redux-observable';

import { deleteImageEpic } from './DeleteImage/DeleteImageEpic';


export default combineEpics(
    deleteImageEpic,
);
